<template>
  <div class="content-wrapper">
    <!-- Admin -->
    <router-link class="item-wrapper admin" v-if="isRuejaiPartnerAdmin"
      :to="{
        name: 'SupplierInvoiceDetail',
        params: {
          invoiceId: this.invoice.id,
          status: this.status
        }
      }">
      <p>{{ buddhistCreatedAt }}</p>
      <p>{{ invoice.invoiceNo }}</p>
      <p>{{ invoice.providerName }}</p>
      <div class="detail-wrapper">
        <div v-for="(project, index) in invoice.projectNames" :key="index">
          <p>{{ project }}</p>
        </div>
      </div>
      <p>{{ buddhistLatestFulfilledMonth }} <span style="font-size: 12px; color: #808080">{{ latestFulfilledMonth }}</span></p>
      <p>{{ invoice.invoiceTotalPrice }}</p>
      <div class="status">
        <p>{{ invoice.status }}</p>
        <p class="description">{{ invoice.appointmentCount }}</p>
      </div>
    </router-link>

    <!-- Partner -->
    <router-link class="item-wrapper provider" v-else
      :to="{
        name: 'SupplierInvoiceDetail',
        params: {
          invoiceId: this.invoice.id,
          status: this.status
        }
      }">
      <p>{{ buddhistCreatedAt }} <span style="font-size: 12px; color: #808080">{{ createdAt }}</span></p>
      <p>{{ invoice.invoiceNo }}</p>
      <div class="detail-wrapper">
        <div v-for="(project, index) in invoice.projectNames" :key="index">
          <p>{{ project }}</p>
        </div>
      </div>
      <p>{{ buddhistLatestFulfilledMonth }} <span style="font-size: 12px; color: #808080">{{ latestFulfilledMonth }}</span></p>
      <p>{{ invoice.invoiceTotalPrice }}</p>
      <div class="status">
        <p>{{ invoice.status }}</p>
        <p class="description">{{ invoice.appointmentCount }}</p>
      </div>
    </router-link>
  </div>
</template>

<script>
import { toLocaleTH } from "@/lib/dateTime";
import { DateTime } from "luxon";
import { permissionRole } from "../../lib/mapper";

export default {
  props: ["invoice", "status"],
  data() {
    return {
      roleId: parseInt(localStorage.getItem("supplierRoleId")),
      buddhistCreatedAt: null,
      createdAt: null,
      buddhistLatestFulfilledMonth: null,
      latestFulfilledMonth: null,
    };
  },
  created() {
    this.setupData();
  },
  methods: {
    setupData() {
      // Set Created At
      this.buddhistCreatedAt = this.dateTimeTH(this.invoice.createdAt)
        .toFormat("dd MMM yyyy");
      this.createdAt = `(${DateTime.fromISO(this.invoice.createdAt)
        .toFormat("yyyy")})`;

      // Set Latest Fulfilled Month
      this.buddhistLatestFulfilledMonth = `${this.dateTimeTH(this.invoice.latestFulfilledMonth)
        .toFormat("MMMM yyyy")}`;
      this.latestFulfilledMonth = `(${DateTime.fromISO(this.invoice.latestFulfilledMonth)
        .toFormat("yyyy")})`;
    },
    dateTimeTH(dateTime) {
      if (!dateTime) return;

      return toLocaleTH(DateTime.fromISO(dateTime));
    }
  },
  computed: {
    isRuejaiPartnerAdmin() {
      return this.roleId === permissionRole.RJPADMIN;
    }
  } 
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.content-wrapper {
  display: flex;
  flex-direction: column;

  > .item-wrapper {
    display: grid;
    width: max-content;
    grid-gap: 16px;
    padding: 12px 24px;
    border-bottom: 1px solid rgba(201, 201, 201, 0.3);
    color: $black;

    &:hover {
      color: inherit;
      text-decoration: none;
      background: #fafafa;
    }

    .detail-wrapper {
      display: flex;
      flex-direction: column;
    }

    .description {
      font-size: $font-14;
      color: $color-gray;
    }

    .center {
      text-align: center;
    }

    p {
      font-size: 14px;
    }
  }

  > .item-wrapper.admin {
    grid-template-columns: 100px 120px 160px 260px 150px 150px 150px;
  }

  > .item-wrapper.provider {
    grid-template-columns: 150px 150px 320px 150px 150px 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/components/InvoiceDashboardInvoiceListItem.vue